export const screw = 'screw'
export const foot = 'foot'
export const nut = 'nut'
export const distanceBolt = 'distanceBolt'

export type ModelName = typeof screw | typeof foot | typeof nut | typeof distanceBolt
export const modelNames = [screw, foot, nut, distanceBolt] as const

export const modelMap: { [key in ModelName]: string } = {
  [screw]: '/models/screw.glb',
  [foot]: '/models/foot.glb',
  [nut]: '/models/nuts.glb',
  [distanceBolt]: ''
}
